type PendingAskFn = () => Promise<unknown>;

const store = new Map<string, PendingAskFn>();

export const setPendingAsk = (conversationId: string, fn: PendingAskFn): void => {
  store.set(conversationId, fn);
};

export const takePendingAsk = (conversationId: string): PendingAskFn | undefined => {
  const fn = store.get(conversationId);
  store.delete(conversationId);
  return fn;
};

/** Non-destructive peek, so a render can tell a first reply is already on its way. */
export const hasPendingAsk = (conversationId: string): boolean => store.has(conversationId);
